import React, { FunctionComponent } from "react";
import { ICardElementWithChildren } from "backend/model/model";
import TextElement from "reportengine/TextElement";
import Text from "reportengine/Text";
import Slide from "reportengine/Slide";
import DomElement from "reportengine/DomElement";
import Portion from "reportengine/Portion";
import SlideTable from "reportengine/SlideTable";
import SlideTableRow from "reportengine/SlideTableRow";
import ProgressBar from "design/components/progress/ProgressBar";
import PercentageBar from "design/components/progress/PercentageBar";

const KPIPerformanceTable = (
  props: React.PropsWithChildren<{
    kpis: ICardElementWithChildren[];
    report: ICardElementWithChildren;
  }>
) => {
  const { kpis } = props;
  //   const lastPeriod = useYearsLastPeriod(item.period?.name || "");
  return (
    <>
      <Slide index={5}>
        <TextElement slideElement="title">KPI Performance Summary</TextElement>
        <TextElement slideElement="period">
          {props.report.period?.name || ""}
        </TextElement>
        <TextElement slideElement="footer">
          {kpis?.[0]?.scorecardname || "Performance Report"}
        </TextElement>
        <Text slideElement="total_cnt">
          <Portion paragraphIndex={0} portionIndex={0}>
            {kpis.length}&nbsp;
          </Portion>
        </Text>
        <SlideTable slideElement="kpi_performance_table">
          {kpis.map((item) => {
            return (
              <SlideTableRow>
                <TextElement slideElement="">{item.name}</TextElement>
                <DomElement slideElement="" typename="image" selector=".item">
                  <div
                    className="item"
                    style={{ width: "120px", height: "40px" }}
                  >
                    <PercentageBar
                      color={`#${item.rangecolor_PERF_YTD_OPEN}`}
                      value={Number(item.PERF_YTD)}
                    />
                  </div>
                </DomElement>
                <TextElement slideElement="">
                  {item.ACT_YTD_prettyvalue}
                </TextElement>
                <TextElement slideElement="">
                  {item.TAR_YTD_prettyvalue}
                </TextElement>
                <TextElement slideElement="">{item.W_prettyvalue}</TextElement>
                <TextElement slideElement="">
                  {item.PERF_W_YTD_prettyvalue}
                </TextElement>
              </SlideTableRow>
            );
          })}
        </SlideTable>
      </Slide>
    </>
  );
};

export default KPIPerformanceTable;
